export const DEFAULT_CAMERA_PROPERTIES = {
  x: 0,
  y: 0,
  rotation: 90,
  angle: 60,
  distance: 300,
  incidents: 0,
}
